import { Link, useParams } from 'react-router';
import { useQuery } from '@tanstack/react-query';

import { ROUTES } from '#/config/routes';
import { ATTACHMENT_POLICY_RECEIPT } from '#/api/platform/attachments';
import { stockReceiptAttachmentsApi } from '#/api/imsMgmt/receipts/stockReceipt/attachments';
import { fetchStockReceiptDetail } from '#/api/imsMgmt/receipts/stockReceipt/fetchDetail';
import { DocumentAttachmentsCard } from '#/modules/commonComponents/attachments';
import { Button } from '#/modules/commonComponents/button';
import { cn } from '#/lib/utils';
import PageShell from '#/modules/infra/layout/PageShell';
import StockReceiptBlock from '#/modules/imsMgmt/receipts/stockReceipt/components/StockReceiptBlock';
import { getStockReceiptApiErrorMessage } from '#/modules/imsMgmt/receipts/stockReceipt/helper/apiError';
import { stockReceiptDetailQueryKey } from '#/utils/queryKeys';

const StockReceiptDetailPage = () => {
  const { id } = useParams();

  const detailQuery = useQuery({
    queryKey: stockReceiptDetailQueryKey(id),
    queryFn: () => fetchStockReceiptDetail(id),
    enabled: Boolean(id),
  });

  const detail = detailQuery.data?.data;
  const isLoading = detailQuery.isLoading;
  const isError = detailQuery.isError;

  return (
    <PageShell variant="detail">
      <div className="layout-shell__body">
        <div className="mx-auto w-full max-w-4xl space-y-4">
          <div
            className={cn(
              'sticky top-0 z-20 -mx-1 flex flex-wrap items-center gap-2',
              'border-b border-slate-200 bg-canvas px-1 pb-3 pt-1',
            )}
          >
            <h1 className="page_title mb-0!">
              <span className="border-l-5 border-primary-400 pl-2.5">入庫單詳情</span>
            </h1>
            <Button type="button" variant="outline" asChild>
              <Link to={ROUTES.stockReceipt}>返回列表</Link>
            </Button>
          </div>

          {isLoading ? (
            <p className="text-sm text-slate-500">載入中…</p>
          ) : null}

          {isError ? (
            <p className="text-sm text-destructive">
              {getStockReceiptApiErrorMessage(detailQuery.error, '載入入庫單失敗')}
            </p>
          ) : null}

          {detail ? (
            <>
              <StockReceiptBlock
                detail={detail}
                defaultOpen
                showActions
                onRefetch={() => detailQuery.refetch()}
              />
              <DocumentAttachmentsCard
                businessId={String(detail.id)}
                ownerKey="stockReceipt"
                api={stockReceiptAttachmentsApi}
                policy={ATTACHMENT_POLICY_RECEIPT}
              />
            </>
          ) : null}
        </div>
      </div>
    </PageShell>
  );
};

export default StockReceiptDetailPage;
